import React from 'react';
import UserDashboardAddJob from 'components/UserDashboard/UserDashboardAddJob/UserDashboardAddJob';

const UserDashboardAddNewJob = () => <UserDashboardAddJob />;

export default UserDashboardAddNewJob;
